import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'
import crypto from '@/lib/crypto.js'
import UserService from '@/lib/user.js'

const authHeader = () => {
    const userService = new UserService
    const token = userService.getToken()

    return {
        'Authorization': `Bearer ${token}`,
    }
}

export default {
    namespaced: true,
    state: {
        name: '',
        isEndQuiz: false,
        currentQuizIndex: 0,
        quiz: {
            _id: '',
            code: '',
            title: '',
            image: '',
            description: '',
            background_color: '',
            background_image: '',
            background_type: '',
            type: '',
            show_result_on_user_device: false,
            questions: []
        },
        userSelected: [],
        isMasterPlayer: false,
        isPlayTogether: false,
        joinAsPlayer: false,
        isPlaySongUser: true,
        masterPlayingAs: 'master',

        delayAnswer: 0,
        delayQuestion: 30,
        timeLimit: true,
        playerSound: {
            questionMusic: true,
            effectMusic: true,
        },

        progressBarStatus: true,

        totalCoin: 0,
        wrongQuestions: [],
        parentQuizCode: null,
        isFromMyQuiz: false,
        playAloneReportToken: null,
        isEmitEndGame: false,

        embedToken: null,
        isFrontPageQuiz: false
    },

    mutations: {

        updateQuiz: function (state, quiz) {

            state.quiz = quiz
        },

        updateIsEndQuiz: function (state, status) {

            state.isEndQuiz = status
        },

        updateCurrentQuizIndex: function (state, index) {

            state.currentQuizIndex = index
        },

        updatePlayerName: function (state, name) {

            state.name = name
        },

        handleSetUserAnswer: function (state, data) {

            state.userSelected = [...state.userSelected, data]
        },

        clearUserAnswer: function (state) {
            state.userSelected = []
        },

        setIsMasterPlayer: function (state, status) {
            state.isMasterPlayer = status
        },

        isPlayTogether: function (state, status) {
            state.isPlayTogether = status
        },

        joinAsPlayer: function (state, status) {
            state.joinAsPlayer = status
        },

        toggleQuizIsPlaySongUser: function (state, status) {
            state.isPlaySongUser = status
        },

        updateDelayAnswer: function (state, value) {
            state.delayAnswer = value
        },

        updateDelayQuestion: function (state, value) {
            state.delayQuestion = value
        },

        updateTimeLimit: function (state, value) {
            state.timeLimit = value
        },

        toggleQuizPlayerSound: function (state, value) {
            state.playerSound = value
        },

        updateProgressBarStatus: function (state, value) {
            state.progressBarStatus = value
        },

        addCoin: function (state) {
            state.totalCoin += 1
        },

        clearCoin: function (state) {
            state.totalCoin = 0
        },

        pushWrongQuestion: function (state, question) {
            state.wrongQuestions.push(question)
        },

        updateManyQuestion: function (state, questions) {
            state.quiz.questions = questions
        },

        clearWrongQuestion: function (state) {
            state.wrongQuestions = []
        },

        setParentQuizCode: function (state, code) {
            state.parentQuizCode = code
        },

        setIsFromMyQuiz: function (state, status) {
            state.isFromMyQuiz = status
        },

        setPlayAloneReportToken: function (state, token) {
            state.playAloneReportToken = token
        },

        setMasterPlayingAs: function (state, as) {
            state.masterPlayingAs = as
        },

        setIsEmitEndGame: function (state, status) {
            state.isEmitEndGame = status
        },

        setEmbedToken: function (state, token) {
            state.embedToken = token
        },

        setIsFrontPageQuiz: function (state, status) {
            state.isFrontPageQuiz = status
        }
    },

    getters: {

        getCurrentQuiz: function(state) {

            let question = state.quiz.questions[state.currentQuizIndex]

            if(question.title) {
                question.title = question.title.split(/\s/g).join(" ")
            }

            return question
        },

        getCurrentQuizAppendScore: function (state) {

            var question = state.quiz.questions[state.currentQuizIndex]

            question.answers.forEach(function (answer, index) {
                question.answers[index].score = 0
            });

            return state.quiz.questions[state.currentQuizIndex] = question
        },

        getQuestionCount: function (state) {

            return state.quiz.questions.length
        },

        joinAsPlayer: function (state) {
            return state.joinAsPlayer
        },

        getIsPlaySongUser: function (state) {

            return state.isPlaySongUser
        },

        getDelayAnswer: function (state) {

            return state.delayAnswer
        },

        getDelayQuestion: function (state) {

            return state.delayQuestion
        },

        getTimeLimit: function (state) {

            return state.timeLimit
        },

        getPlayerSound: function (state) {

            return state.playerSound
        },

        getProgressBarStatus: function (state) {
            return state.progressBarStatus
        },

        totalCoin: function (state) {

            return state.totalCoin
        },

        wrongQuestions: function (state) {
            return state.wrongQuestions
        },

        parentQuizCode: function (state) {
            return state.parentQuizCode
        },

        isFromMyQuiz: function (state) {
            return state.isFromMyQuiz
        },

        playAloneReportToken: function (state) {
            return state.playAloneReportToken
        },

        masterPlayingAs: function (state) {
            return state.masterPlayingAs
        }
    },

    actions: {

        handleNextResult: function (context) {

            var questionCount = context.state.quiz.questions.length

            context.commit('updateIsEndQuiz', (context.state.currentQuizIndex + 1) == questionCount)
        },

        handleNextQuestionIndex: function (context) {

            var nextQuizIndex = context.state.currentQuizIndex + 1

            context.commit('updateCurrentQuizIndex', nextQuizIndex)
        },

        joinQuiz: function (context, {code, name}) {

            var request = new Request

            context.commit('toggleMainLoader', true, { root: true })

            return new Promise(function (resolve, reject) {

                request.post(appConfig.api.joinQuiz, {code, name})
                    .then(function (res) {

                        var quiz = JSON.stringify(res.data.data)

                        quiz = crypto.dec(quiz)

                        context.commit('toggleMainLoader', false, { root: true })
                        context.commit('updateQuiz', quiz)
                        resolve(quiz)
                    })
                    .catch(function (err) {

                        context.commit('toggleMainLoader', false, { root: true })
                        reject(err.response)
                    })
            })
        },

        login3rd: function (ctx, user) {

            const request = new Request

            return new Promise((resolve, reject) => {

                request.post(appConfig.api.login3rd, user)
                    .then(res => [
                        resolve(res)
                    ])
                    .catch(err => {
                        reject(err)
                    })
            })
        },

        joinQuizValidation: function (ctx, captcha_response) {

            const request = new Request

            return new Promise((resolve, reject) => {

                request.post(appConfig.api.joinQuizValidation, captcha_response)
                    .then(res => [
                        resolve(res)
                    ])
                    .catch(err => {
                        reject(err)
                    })
            })
        },

        fetchQuizByCode: function (ctx, data) {

            const request = new Request();

            return new Promise((resolve, reject) => {

                request
                    .get(appConfig.api.fetchQuizByCode.replace(/__id__/, data.code))
                    .then((res) => [
                        resolve(res)
                    ])
                    .catch((err) => {
                        reject(err);
                    });
            })
        },

        saveSponsorQuizScore: function (ctx, data) {
            const request = new Request();

            return new Promise((resolve, reject) => {

                request
                    .post(appConfig.api.saveSponsorQuizScore, data)
                    .then((res) => [
                        resolve(res)
                    ])
                    .catch((err) => {
                        reject(err);
                    });
            })
        },

        sponsorQuizTrack: function (ctx, data) {
            const request = new Request();

            return new Promise((resolve, reject) => {

                request
                    .post(appConfig.api.saveSponsorQuizTracker, data)
                    .then((res) => [
                        resolve(res)
                    ])
                    .catch((err) => {
                        reject(err);
                    });
            })
        },

        updateUserInfoInRanking: function (ctx, data) {
            const request = new Request();

            return new Promise((resolve, reject) => {
                request
                    .patch(appConfig.api.updateUserInfoInRanking, data)
                    .then((res) => [
                        resolve(res)
                    ])
                    .catch((err) => {
                        reject(err);
                    });
            })
        },

        getRankingInfo: function (ctx, data)  {

            const request = new Request();

            return new Promise((resolve, reject) => {

                request
                    .post(appConfig.api.getRankingInfo.replace(/__id__/, data.id), {
                        user_id: data.userId
                    })
                    .then((res) => [
                        resolve(res)
                    ])
                    .catch((err) => {
                        reject(err);
                    });
            })
        },

        savePlayAloneReport (ctx, data) {
            const request = new Request({
                headers: {
                    ...authHeader()
                }
            })

            return new Promise((resolve, reject) => {

                request.post(appConfig.api.savePlayAloneReport.replace(/__id__/, data.quiz_id), data)
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        },

        saveNotLoggedInPlayAloneReport (ctx, data) {
            const request = new Request()

            return new Promise((resolve, reject) => {

                request.post(appConfig.api.saveNotLoggedInPlayAloneReport.replace(/__id__/, data.quiz_id), data)
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
        },

        emitUserEndGameToSocket: function (ctx, data) {
            if (ctx.state.isEmitEndGame) {
                return
            }

            data.socket.emit('user_end_game', {
                room: data.room,
                name: data.name,
                remove_user: true
            })

            ctx.commit('setIsEmitEndGame', true)

        }
    }
}
